import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/ui-bits';
import { Save, Mail } from 'lucide-react';
import { toast } from 'sonner';

export default function SuperSmtpPage() {
  const [form, setForm] = useState({ host: '', port: 587, username: '', password: '', from_email: '', use_tls: true, active: true });
  const load = async () => { const { data } = await api.get('/superadmin/smtp'); if (data.smtp) setForm({ ...form, ...data.smtp }); /* eslint-disable-next-line */};
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const save = async () => { try { await api.put('/superadmin/smtp', form); toast.success('SMTP global guardado'); } catch (err) { toast.error(err?.response?.data?.detail || 'Error'); } };
  return (
    <div>
      <PageHeader title="SMTP global" description="Fallback para tenants sin SMTP propio." />
      <div className="surface p-5 max-w-2xl">
        <h2 className="font-display font-semibold flex items-center gap-2"><Mail className="h-4 w-4" /> Configuración</h2>
        <div className="mt-3 grid gap-3">
          <label>Host<input value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} className="input mt-1" /></label>
          <div className="grid grid-cols-2 gap-2">
            <label>Puerto<input type="number" value={form.port} onChange={(e) => setForm({ ...form, port: Number(e.target.value) })} className="input mt-1" /></label>
            <label className="flex items-end gap-2"><input type="checkbox" checked={form.use_tls} onChange={(e) => setForm({ ...form, use_tls: e.target.checked })} /> TLS</label>
          </div>
          <label>Usuario<input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="input mt-1" /></label>
          <label>Contraseña<input type="password" placeholder="••••" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input mt-1" /></label>
          <label>From<input type="email" value={form.from_email} onChange={(e) => setForm({ ...form, from_email: e.target.value })} className="input mt-1" /></label>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Activo</label>
          <button data-testid="super-smtp-save" onClick={save} className="btn-primary"><Save className="h-4 w-4" /> Guardar</button>
        </div>
      </div>
    </div>
  );
}
